'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function isVariant(definition) {
    return typeof definition === "object";
}

exports.isVariant = isVariant;
